<div class="table-root-child">
      <div class="table-action-wrapper">
        <div class="table-action-inner d-flex align-items-center justify-content-between">
        <div class="d-flex">
          <div id="wo_sv_search" class="search-input">
            <img
              src="../../assets/icons/search.svg"
              alt="Search icon"
              (click)="search()"
            />
            <input
              type="text"
              [placeholder]="'COMMON.SEARCH' | translate"
              [(ngModel)]="searchText"
              (keydown.enter)="search()"
              (ngModelChange)="this.searchTextUpdate.next($event)"
            />
          </div>
          <div id="wo_sv_search-by" class="search-type-picker">
            <div class="dropdown" #stTrigger (click)="openDropdown('st', stTrigger)" click-stop-propagation>
              <span>{{'COMMON.BY' | translate}}:</span>
              <span>{{ selectedSearchTypeDisplay | translate }}</span>
              <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
            </div>
            <div class="dropdown-opened" *ngIf="showSelectSearchType" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
              <div
                [id]="'wo_sv_search-by-' + (i + 1)"
                (click)="selectSearchType(searchType)"
                *ngFor="let searchType of searchByOptions; let i = index">
                <div>{{ searchType.translation | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-auto d-flex">
          <div>
            <div class="d-flex">
              <div id="wo_sv_date-from" class="datepicker-container" style="width: 24rem;">
                <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
                <input
                  type="date"
                  id="dateFrom"
                  name="dateFrom"
                  [ngClass]="
                    dateFrom > dateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="dateFrom"
                  (change)="datesValid() == true && search()"
                />
              </div>

              <div id="wo_sv_date-to" class="datepicker-container">
                <label for="dateTo" class="right-label">
                  {{ "COMMON.TO" | translate }}:
                </label>
                <input
                  type="date"
                  id="dateTo"
                  name="dateTo"
                  [ngClass]="
                    dateFrom > dateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="dateTo"
                  (change)="datesValid() == true && search()"
                />
              </div>
              <div
                id="wo_sv_sort-by"
                class="sort-by-root"
                #sbTrigger
                (click)="openDropdown('sb', sbTrigger)"
                click-stop-propagation
              >
                <div class="dropdown">
                  <span>{{ "COMMON.SORT_BY.TITLE" | translate }}:</span>
                  <span
                    >{{ sortByLabelValue.translation | translate
                    }}<img
                      *ngIf="sortByLabelValue.arrow !== 'no'"
                      [ngClass]="{
                        'arrow-up': sortByLabelValue.arrow === 'up'
                      }"
                      src="../../../assets/icons/arrow.svg"
                  /></span>
                  <span
                    ><img
                      src="../../assets/icons/gray-arrow-down.svg"
                      alt="Gray arrow down"
                  /></span>
                </div>
                <div class="dropdown-opened" *ngIf="showSortBy" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                  <div id="wo_sv_sort-by-newest" (click)="sortBy(sortByOptions.NEWEST)">
                    <div>{{ "COMMON.SORT_BY.NEWEST" | translate }}</div>
                  </div>
                  <div id="wo_sv_sort-by-oldest" (click)="sortBy(sortByOptions.OLDEST)">
                    <div>{{ "COMMON.SORT_BY.OLDEST" | translate }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center download-btn" *ngIf="permissionsService.isSiteVerificationDownloadAllowed" (click)="download()">
            <span>{{'COMMON.DOWNLOAD' | translate}}</span>
          </div>
        </div>
        </div>
      </div>

      <div class="filter">
        <div class="filter-list">
          {{ "COMMON.FILTER" | translate }}
          <app-multi-select-dropdown
            id="wo_sv_region_filter"
            class="multiselect"
            [clicked]="clicked"
            [items]="hasCimDataIntegration ? geographicalRegions : regions"
            [label]="'COMMON.BU.PLURAL'"
            [showMore]="false"
            [requireApply]="true"
            (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)"
          >
          </app-multi-select-dropdown>
          <app-multi-select-dropdown
            id="wo_sv_area_filter"
            class="multiselect"
            [clicked]="clicked"
            [items]="hasCimDataIntegration ? subGeographicalRegions : areas"
            [label]="'COMMON.UT.PLURAL'"
            [showMore]="false"
            [requireApply]="true"
            (shareIndividualCheckedList)="selectArea($event)"
          >
          </app-multi-select-dropdown>
          <app-multi-select-dropdown
            id="wo_sv_status_filter"
            class="multiselect"
            [clicked]="clicked"
            [items]="statusItems"
            [label]="'COMMON.TABLE_HEADERS.CURRENT_STATUS'"
            [showMore]="false"
            [requireApply]="true"
            (shareIndividualCheckedList)="selectStatus($event)"
          >
          </app-multi-select-dropdown>
          <select
            id="wo_sv_tag_filter"
            name="tag-select"
            (change)="selectTag($event)"
            class="form-select"
          >
            <option value="" [selected]="tag === undefined" disabled>
              {{ "COMMON.TAG.TITLE" | translate }}
            </option>
            <option
              [id]="'wo_sv_tag_filter-' + (i + 1)"
              [selected]="tag == t.value"
              *ngFor="let t of tagOptions; let i = index"
              value="{{ t.value }}"
            >
              {{ t.translation | translate }}
            </option>
          </select>
          <select (change)="selectSltStatus($event)" class="form-select" [disabled]="isSltDropdownDisabled">
            <option value="" [selected]="!selectedSltStatus" disabled>{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</option>
            <option [id]="'new_service_service-type-' + (i + 1)" [selected]="selectedSltStatus == s.id"
              *ngFor="let s of sltOptions; let i = index" value="{{ s.id }}">
              {{ s.displayValue | translate }}
            </option>
          </select>
          <select (change)="selectSubserviceType($event)" class="form-select">
            <option value="" [selected]="!selectedSubserviceType" disabled>{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</option>
            <option [id]="'new_service_service-type-' + (i + 1)" [selected]="selectedSubserviceType == s.value"
              *ngFor="let s of subServiceTypeOptions; let i = index" value="{{ s.value }}">
              {{ s.displayValue | translate }}
            </option>
          </select>
          <select (change)="selectProjectType($event)" class="form-select">
            <option value="" [selected]="!selectedProjectType" disabled>{{'NEW_SERVICE.PROJECT_STATUS' | translate}}</option>
            <option [id]="'new_service_project-status-' + (i + 1)" [selected]="selectedProjectType == s.value"
              *ngFor="let s of projectTypeOptions; let i = index" value="{{ s.value }}">
              {{ s.displayValue | translate }}
            </option>
          </select>
        </div>
        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist
            [filters]="selectedFilters"
            [useApply]="true"
            (resetFilterEmitter)="resetFilter()"
            (removeFilterEmitter)="removeFilter($event)"
            (applyFilterEmitter)="applyFilter($event)"
          >
          </app-filter-checklist>
        </div>
      </div>
      <div class="table table-overflow my-4">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="wo_sv_table_header_checkbox">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="isAllCheckBoxChecked()"
                    (change)="checkAllCheckBox()"
                  />
                </th>
                <th id="wo_sv_table_header_app-num">{{ "COMMON.TABLE_HEADERS.APP_NUM" | translate }}</th>
                <th id="wo_sv_table_header_building-owner">{{ "COMMON.TABLE_HEADERS.BUILDING_OWNER" | translate }}</th>
                <th id="wo_sv_table_header_address">{{ "COMMON.ADDRESS" | translate }}</th>
                <th id="wo_sv_table_header_meter_count">{{ "NEW_SERVICE.REQUEST_COUNT" | translate }}</th>
                <th id="wo_sv_table_header_region">{{ "COMMON.BU.SINGLE" | translate }}</th>
                <th id="wo_sv_table_header_district">{{ "COMMON.UT.SINGLE" | translate }}</th>
                <th id="wo_sv_table_header_current-status">{{ "COMMON.TABLE_HEADERS.CURRENT_STATUS" | translate }}</th>
                <th id="new_service_table_header_sltStatus">{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</th>
                <th id="new_service_table_header_subserviceType">{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</th>
                <th id="new_service_table_header_projectStatus">{{'NEW_SERVICE.PROJECT_STATUS' | translate}}</th>
                <th id="wo_sv_table_header_tag">{{ "COMMON.TAG.TITLE" | translate }}</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                [id]="'wo_sv_table_row-' + (i + 1)"
                *ngFor="
                  let siteVerification of siteVerifications;
                  let i = index
                "
                (click)="selectVerification(siteVerification.id)"
              >
                <td [id]="'wo_sv_table_checkbox-' + (i + 1)">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    value="{{ siteVerification.id }}"
                  />
                </td>

                <td [id]="'wo_sv_table_app-num-' + (i + 1)" (click)="setFilterStorage()">
                  {{ siteVerification.applicationNumber | hasValue }}
                </td>
                <td [id]="'wo_sv_table_building-owner-' + (i + 1)" (click)="setFilterStorage()">
                  {{ siteVerification?.buildingOwner | hasValue }}
                </td>
                <td [id]="'wo_sv_table_address-' + (i + 1)" (click)="setFilterStorage()">
                  {{ siteVerification.address | hasValue }}
                </td>
                <td [id]="'wo_scc_table-count-' + (i + 1)">
                  {{ siteVerification.meterCount | hasValue }}
                </td>
                <td [id]="'wo_sv_table_region-' + (i + 1)" (click)="setFilterStorage()">
                  {{ (hasCimDataIntegration ? siteVerification.geographicalRegion : siteVerification.region) | hasValue }}
                </td>
                <td [id]="'wo_sv_table_area-' + (i + 1)" (click)="setFilterStorage()">
                  {{ (hasCimDataIntegration ? siteVerification.subGeographicalRegion : siteVerification.area) | hasValue }}
                </td>
                <td [id]="'wo_sv_table_current-status-' + (i + 1)" (click)="setFilterStorage()">
                  <div
                    *ngIf="siteVerification.status"
                    class="building-status"
                    [ngClass]="{
                      'assigned-building':
                        siteVerification.status.toString() == 'Assigned',
                      'rejected-building':
                        siteVerification.status.toString() == 'Rejected',
                      'approved-building':
                        siteVerification.status.toString() == 'Approved',
                      'unvalidated-building':
                        siteVerification.status.toString() == 'New',
                      'submitted-building':
                        siteVerification.status.toString() == 'Submitted',
                      'suspended-building':
                        siteVerification.status.toString() == 'Suspended'
                    }"
                  >
                    {{ siteVerification.status }}
                  </div>
                </td>
                <td [id]="'wo_sv_table_service-type-' + (i + 1)">{{ siteVerification.sltStatus | hasValue }}</td>
                <td [id]="'wo_sv_table_sub-service-type-' + (i + 1)">{{ siteVerification.subserviceType | hasValue }}</td>
                <td [id]="'wo_scc_table-projectStatus-' + (i + 1)">{{ siteVerification.projectStatus | hasValue }}</td>
                <td [id]="'wo_sv_table_tag-' + (i + 1)" (click)="setFilterStorage()">
                  <div
                    class="building-status"
                    [ngClass]="{
                      'assigned-building': siteVerification.tag == 'New Customer',
                      'approved-building': siteVerification.tag == 'Existing'
                    }"
                  >
                    {{ siteVerification.tag | hasValue }}
                  </div>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
      </div>
      <div>
            <app-paging
              *ngIf="count > 0"
              [pageSize]="pageSize"
              [count]="count"
              [currentPage]="currentPage"
              [useDirect]="true"
              (pageChange)="pageChange($event)"
            ></app-paging>
          </div>
    </div>